// Excel helpers for the staffing plan. The backend builds and parses the
// workbook; the browser only moves base64 around.

export const PLAN_IMPORT_MAX_BYTES = 2 * 1024 * 1024;

/** Request timeout for import calls; a stuck request should not hang the dialog forever. */
export const PLAN_IMPORT_TIMEOUT_MS = 30000;

const XLSX_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

/** Saves a base64 .xlsx as a download (same approach as the reports page). */
export function downloadBase64Xlsx(base64Data: string, fileName: string) {
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const blob = new Blob([new Uint8Array(byteNumbers)], { type: XLSX_MIME });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

/** Reads a file as plain base64 (without the "data:...;base64," prefix). */
export function readFileAsBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = String(reader.result ?? '');
      const comma = result.indexOf(',');
      resolve(comma >= 0 ? result.slice(comma + 1) : result);
    };
    reader.onerror = () => reject(new Error('Nie udało się odczytać pliku'));
    reader.readAsDataURL(file);
  });
}

/** "06:00-14:00" → "06:00–14:00", "W" → "W (wolne)", "" → "puste". */
export function importCellLabel(value: string): string {
  if (!value) return 'puste';
  if (value === 'W') return 'W (wolne)';
  return value.replace('-', '–');
}
